module.exports = __webpack_public_path__ + "img/McD_McDrive_Content_images_01.e60906a8.jpg";